/**
 * UNAUTHORIZED PAGE
 *
 * Displayed when a user tries to access a resource they don't have permission for.
 */

import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldAlert, Home } from 'lucide-react';

export default function UnauthorizedPage() {
  return (
    <div className='flex min-h-screen items-center justify-center p-4'>
      <Card className='max-w-md w-full'>
        <CardHeader className='text-center'>
          <div className='flex justify-center mb-4'>
            <ShieldAlert className='h-16 w-16 text-red-500' />
          </div>
          <CardTitle className='text-2xl'>Access Denied</CardTitle>
          <CardDescription>
            You don't have permission to access this page
          </CardDescription>
        </CardHeader>
        <CardContent className='space-y-4'>
          <p className='text-sm text-muted-foreground text-center'>
            This page is restricted to users with specific team memberships or roles. 
            If you believe you should have access, please contact your administrator.
          </p>
          <Button asChild className='w-full'>
            <Link to='/home'>
              <Home className='mr-2 h-4 w-4' />
              Return to Home
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
